module.exports = __webpack_public_path__ + "img/goals.6a4956ce.png";